import * as React from "react";
function SvgSheets(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M17.5 33.7h10.4v2.6H17.5v-2.6zm0-16.8h20.8v2.6H17.5v-2.6zm0 9h20.8v2.6H17.5v-2.6zM41.9 7.8h-3.6V4c-.1-2.2-1.9-4-4.2-4H5.6C3.5.1 1.8 1.8 2 3.9v32.7c-.1 1.9 1.3 3.5 3.2 3.6h4.5v3.4c0 2.2 1.4 4.4 3.6 4.4H37l9.1-9.1V11.2c0-2.2-2.1-3.4-4.2-3.4zM9.7 10.6v27H5.6c-.5.1-1-.3-1-.8V4c-.2-.6.2-1.3.9-1.4H34c.8 0 1.4.6 1.6 1.4v3.8H13.4c-1.8-.3-3.4 1-3.7 2.8zm28.6 32.2v-2.6h2.6l-2.6 2.6zm5.2-5.2h-7.8v7.8H13.4c-.8 0-1-1-1-1.8V11.2c0-.8.3-.8 1-.8h28.5c.6 0 1.6 0 1.6.8v26.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSheets);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
